import { useErrorStore } from '~/stores/common/error.store';

export const handleCommonActions = async (actionCallback, finalCallback = () => {}) => {
    const errorStore = useErrorStore();

    try {
        errorStore.setError();
        await actionCallback();
    } catch (error) {
        errorStore.setError(error);
    } finally{
        finalCallback();
    }
};